import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SchemeLocationFilter, LocationFilterByOrganizationId, LocationFilterByOrganizationTag, TagItem, LocationFilterByOutlet, LocationFilterByOutletProperty } from 'src/app/api/api-campaigns.service.generated';
import { AdvertiserOrganizationsSearchComponent } from 'src/app/advertiser/advertiser-details/advertiser-organizations-search/advertiser-organizations-search.component';
import { OrganizationTagSelectComponent } from 'src/app/advertiser/advertiser-details/advertiser-campaigns/_/organization-tag-select/organization-tag-select.component';
import { OutletSearchComponent } from 'src/app/common/components/outlet-search/outlet-search.component';
import { OutletPropertySelectComponent } from 'src/app/common/components/outlet-property-select/outlet-property-select.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FilterByOrganizationIdComponent } from 'src/app/common/components/filter-by-organization-id/filter-by-organization-id.component';
import { FilterByOrganizationTagComponent } from 'src/app/common/components/filter-by-organization-tag/filter-by-organization-tag.component';
import { FilterByOutletComponent } from 'src/app/common/components/filter-by-outlet/filter-by-outlet.component';
import { FilterByOutletPropertyComponent } from 'src/app/common/components/filter-by-outlet-property/filter-by-outlet-property.component';
import { LoadingOverlayComponent, ButtonComponent } from 'wecheer-common';
import { FlexLayoutModule } from '@angular/flex-layout';

export enum LocFilterType {
  ByOrganizationId = 'LocationFilterByOrganizationId',
  ByOrganizationTag = 'LocationFilterByOrganizationTag',
  ByOutlet = 'LocationFilterByOutlet',
  ByOutletProperty = 'LocationFilterByOutletProperty'
}

@Component({
  selector: 'app-opener-scheme-location-filters',
  templateUrl: './opener-scheme-location-filters.component.html',
  styleUrls: ['./opener-scheme-location-filters.component.scss'],
  imports: [
    MatMenuModule,
    MatIconModule,
    FlexLayoutModule,
    FilterByOrganizationIdComponent,
    FilterByOrganizationTagComponent,
    FilterByOutletComponent,
    FilterByOutletPropertyComponent,
    LoadingOverlayComponent,
    ButtonComponent
]
})
export class OpenerSchemeLocationFiltersComponent {
  private dialog = inject(MatDialog);

  model: SchemeLocationFilter;
  LocFilterType = LocFilterType;

  isLoading: boolean;

  currentView = 0;

  public setFormValue(model: SchemeLocationFilter) {
    this.model = model || new SchemeLocationFilter({ filters: [] });
  }

  public getFormValue() {
    return this.model;
  }

  async onAddFilter_ByOrganizationId() {
    const org = await AdvertiserOrganizationsSearchComponent.open(this.dialog, undefined);
    if (!org) return;

    let filter = this.model.filters && this.model.filters.find(f => f.type === LocFilterType.ByOrganizationId) as LocationFilterByOrganizationId;
    if (!filter) {
      filter = new LocationFilterByOrganizationId({ type: LocFilterType.ByOrganizationId, organizationIds: [org.id.toString()] });
      this.model.filters.push(filter);
      return;
    }

    if (!filter.organizationIds)
      filter.organizationIds = [];

    filter.organizationIds.push(org.id.toString());
    this.rebind();
  }

  onDeleteOrganisationId(orgId: string) {
    const filter = this.model.filters.find(f => f.type === LocFilterType.ByOrganizationId);
    const filterById = filter as LocationFilterByOrganizationId;
    const ix = filterById.organizationIds.indexOf(orgId);
    filterById.organizationIds.splice(ix, 1);

    if (filterById.organizationIds.length === 0)
      this.onDeleteFilter(filter);

    this.rebind();
  }

  async onAddFilter_ByOrganizationTag() {
    const kvTags = await OrganizationTagSelectComponent.open(this.dialog);
    if (!kvTags) return;

    const tags = kvTags.map(kv => new TagItem({ tag: kv.tag, value: kv.value }));
    const filter = new LocationFilterByOrganizationTag({ type: LocFilterType.ByOrganizationTag, tags: tags });
    this.model.filters.push(filter);
  }

  async onAddFilter_ByOutlet() {
    const outlet = await OutletSearchComponent.open(this.dialog, undefined);
    if (!outlet) return;

    let filter = this.model.filters && this.model.filters.find(f => f.type === LocFilterType.ByOutlet) as LocationFilterByOutlet;
    if (!filter) {
      filter = new LocationFilterByOutlet({ type: LocFilterType.ByOutlet, outletIds: [outlet.id.toString()] });
      this.model.filters.push(filter);
      return;
    }

    if (!filter.outletIds)
      filter.outletIds = [];

    filter.outletIds.push(outlet.id.toString());
    this.rebind();
  }

  onDeleteOutlet(outletId: string) {
    const filter = this.model.filters.find(f => f.type === LocFilterType.ByOutlet);
    const filterById = filter as LocationFilterByOutlet;
    const ix = filterById.outletIds.indexOf(outletId);
    filterById.outletIds.splice(ix, 1);

    if (filterById.outletIds.length === 0)
      this.onDeleteFilter(filter);

    this.rebind();
  }

  async onAddFilter_ByOutletProperty() {
    const props = await OutletPropertySelectComponent.open(this.dialog);
    if (!props) return;

    //const tags = kvTags.map(kv => new TagItem({ tag: kv.tag, value: kv.value }));
    const filter = new LocationFilterByOutletProperty({ type: LocFilterType.ByOutletProperty, outletPropertyItems: props });
    this.model.filters.push(filter);
  }

  onDeleteFilter(filter: any) {
    const ix = this.model.filters.indexOf(filter);
    this.model.filters.splice(ix, 1);
  }

  rebind() {
    for (let i = 0; i < this.model.filters.length; i++) {
      this.model.filters[i] = { ...this.model.filters[i] };
    }

  }

  getTags(filter: LocationFilterByOrganizationTag) {
    return filter.tags;
  }

}
